<!-- 设备参数设置 -->
<template>
  <el-dialog v-bind="$attrs" v-on="$listeners" :close-on-click-modal="false">
    <el-table stripe size="small" :data="records" :border="true" v-loading="loading" height="60vh">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column prop="paramName" label="参数名称" width="200"></el-table-column>
      <el-table-column prop="address" label="寄存器地址" width="100" align="center"></el-table-column>
      <el-table-column prop="paramValue" label="参数值" align="center" width="180" v-slot="{row}">
        <el-switch v-model="row.paramValue" :active-value="1" :inactive-value="0"
                   active-text="ON"
                   inactive-text="OFF"
                   v-if="row.dataType==='BIT'"></el-switch>
        <el-input-number v-model="row.paramValue" :min="row.min" :max="row.max" style="width:130px" v-else></el-input-number>
      </el-table-column>
      <el-table-column prop="unit" label="单位" align="center" width="60"></el-table-column>
      <el-table-column prop="remark" label="参数说明" min-width="200"></el-table-column>
      <el-table-column prop="action" label="操作" width="90" align="center" fixed="right" v-slot="{row}">
        <el-button type="text" title="设置参数" @click="setParam(row.address, row.paramValue)">设置</el-button>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="readParams" :disabled="isMulti">读取参数</el-button>
      <el-button type="danger" @click="resetDevice" :disabled="isMulti">恢复出厂设置</el-button>
<!--      <el-button type="primary" @click="setParams">写入参数</el-button>-->
    </template>
  </el-dialog>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
import SessionStore from "@/utils/SessionStore";

export default {
  extends: BaseVue,
  props: {
    deviceCode: {
      required: true
    }
  },
  data() {
    return {
      isMulti: false,
      socket: null,
      records: []
    }
  },
  created() {
    // 弹窗层兜底：仅系统管理员、单位管理员可配置（对齐 acc-app）
    if (!SessionStore.canSettingDeviceParams()) {
      this.$message.warning("仅系统管理员或单位管理员可配置设备参数");
      this.$emit("close");
      return;
    }
    this.isMulti = this.deviceCode.split(",").length > 1;
    // this.listenSocket();
    this.postForm("/common/sensor-params", { deviceCode: this.deviceCode }, true).then(dr=>{
      this.records = dr.rows;
      if(!this.isMulti) {
        this.listenSocket();
      }
    })
  },
  beforeDestroy() {
    if(this.socket != null) {
      this.socket.close();
    }
  },
  methods: {
    close(){
      this.$emit("close");
    },
    readParams(){
      this.postForm("/device/readParam",{
        deviceCode: this.deviceCode
      }, true);
    },
    /**
     * 设置单个参数；非管理员直接拒绝
     * @param {number} address 寄存器地址
     * @param {number} value 参数值
     */
    setParam(address, value){
      // 操作前再次校验权限，避免绕过入口直接调用
      if (!SessionStore.canSettingDeviceParams()) {
        this.$message.warning("仅系统管理员或单位管理员可配置设备参数");
        return;
      }
      this.loading = true;
      this.postForm("/device/setParam",{
        deviceCode: this.deviceCode,
        address: address,
        value: value
      }, true).finally(()=>{
        this.loading = false;
      });
    },
    resetDevice() {
      this.$confirm("确定要恢复出厂设置吗？","非厂家人员严禁操作", {
        type: "warning"
      }).then(()=>{
        this.setParam(40, 1);
      })
    },
    listenSocket(){
      this.socket = new WebSocket(this.globalConfig.wsRoot+"/settings-push/"+this.deviceCode);
      this.socket.onmessage = (e)=>{
        console.log(e.data);
        const list = JSON.parse(e.data);
        if (!Array.isArray(list)) {
          return;
        }
        // 按地址合并参数值，保留当前账号可见的参数列表（单位管理员仅已授权项）
        const valueMap = {};
        list.forEach(item => {
          if (item && item.address != null) {
            valueMap[item.address] = item.paramValue;
          }
        });
        this.records.forEach(row => {
          if (Object.prototype.hasOwnProperty.call(valueMap, row.address)) {
            this.$set(row, "paramValue", valueMap[row.address]);
          }
        });
      }
      this.socket.onclose = () => {
        console.log("socket is closed");
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>